/**
 * Nav Accordion (Side Nav)
 * Handles Accordion functions for Side Nav
 * @module navAccordion
 */
import $ from 'jquery';
import registerJQueryPlugin from '../lib/register-jquery-plugin';
import mergeOptions from '../lib/merge-options';

export const PLUGIN_NAME = 'navAccordion';

export const CLICK_EVENT = 'click';

export const DEFAULTS = {

};
/**
 * Handles the dropdown arrow toggle when the target has been clicked.
 * @private
 * @param {jQuery.Event} evt - A jQuery event
 */
const itemtoggleHandler = (evt) => {
  // rotate dropdown arrow
  const target = evt.target;
  const parentSubIcons = $(target)
  .parent()
  .siblings()
  .find('.nav-list__icon');
  const siblingSubIcons = $(target)
  .siblings()
  .find('.nav-list__icon');

  $(target).children('.nav-list__icon').toggleClass('dd-is-open');
  parentSubIcons.removeClass('dd-is-open');
  siblingSubIcons.removeClass('dd-is-open');
};
/**
 * Set Event setEventListeners
 * @param  {jQuery} $el - accordion element
 */
const accordionEventHandler = (evt) => {
  // code below needs to be refactored
  const headers = ['A', 'BUTTON'];
  const target = evt.target;
  const name = target.nodeName.toUpperCase();

  if ($.inArray(name, headers) > -1) {
    if ($(target).attr('href') === '#' || name === 'BUTTON') {
      evt.preventDefault();
    }
    const subItem = $(target).next();
    // slideUp all elements (except target) at current depth or greater
    const depth = $(subItem).parents().length;
    const allAtDepth = $('.nav-accordion ul').filter(function filterItems() {
      if ($(this).parents().length >= depth && this !== subItem.get(0)) {
        return true;
      }
      return false;
    });
    $(allAtDepth).slideUp('fast');
    subItem.slideToggle('fast', function closeList() {
      $('.nav-list__link--view-all').removeClass('is-active');
      $(this).children('li').children('a.nav-list__link--view-all').addClass('is-active');
    });

    const $target = $(target);
    const $L1_L2_BUTTONS = $('#js-nav-side button[aria-expanded="true"]');
    const $PARENT_BUTTON = $target.parents('.nav-list').prev('button');

    if ($target.attr('aria-expanded') === 'false') {
      // Reset level-1 & level-2 buttons to false
      $L1_L2_BUTTONS.attr('aria-expanded', false);

      // Set target to true
      if ($target.is('button')) {
        $target.attr('aria-expanded', true);
      }

      // Keep menu level-1 to true if level-2 is open
      $PARENT_BUTTON.attr('aria-expanded', true);
    } else {
      // Reset level-1 & level-2 buttons to false
      $L1_L2_BUTTONS.attr('aria-expanded', false);

      // Keep menu level-1 to true if level-2 is closed
      $PARENT_BUTTON.attr('aria-expanded', true);
    }
  }
};
/**
 * Apply Event Handlers
 * @param  {jQuery} $el - accordion element
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
const applyEventHandlers = ($el, opts) => {
  $el.on(CLICK_EVENT, (evt) => {
    accordionEventHandler(evt, $el, opts);
    itemtoggleHandler(evt);
  });
};
/**
 * Initializes Header.
 * @param {HTMLElement} el - accordion element
 * @param {Object} options - Options used for wiring up the modal
 * @see DEFAULTS
 */
export default function navAccordion(el, options = {}) {
  const $el = $(el);
  const opts = mergeOptions(DEFAULTS, options, $el);
  applyEventHandlers($el, opts);
}

registerJQueryPlugin(PLUGIN_NAME, navAccordion);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/nav-accordion.js